

export class UserDTO {
    private constructor(private _name: string, private _isAdmin: boolean, private _isManager: boolean, private _isOwner: boolean, private _isStaff: boolean, private _userId: string, private _customerId?: string) { }

    get name(): string {
        if (!!this._name)
            return this._name
        return ""
    }

    get isAdmin(): boolean {
        if (!!this._isAdmin)
            return this._isAdmin
        return false
    }

    get isManager(): boolean {
        if (!!this._isManager)
            return this._isManager
        return false
    }
    get isStaff(): boolean {
        if (!!this._isStaff)
            return this._isStaff
        return false
    }
    get isOwner(): boolean {
        if (!!this._isOwner)
            return this._isOwner
        return false
    }
    get id(): string {
        if (!!this._userId)
            return this._userId
        return ""
    }

    get customerId(): string {
        if (!!this._customerId)
            return this._customerId
        return ""
    }


    static fromJSON(userJson: any): UserDTO | undefined {
        if (!!userJson) {
            return new UserDTO(userJson.name, userJson.isAdmin, userJson.isManager, userJson.isOwner, userJson.isStaff, userJson.id, userJson.customerId);
        }
    }

    toJson() {
        return {

            name: this.name,
            isAdmin: this.isAdmin,
            isManager: this.isManager,
            isStaff: this.isStaff,
            isOwner: this.isOwner,
            customerId: this.customerId,
            id: this.id,

        }
    }

}